import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'
import formatDate from '@/utils/formatDate'

export default {
  namespaced: true,
  actions: {
    async createCustomer(context, customer) {
      const response = await http.post(`customer/`, {
        name: customer.name,
        surname: customer.surname,
        titleBefore: customer.titleBefore,
        titleAfter: customer.titleAfter,
        gender: customer.genderName,
        phone: customer.phone,
        email: customer.email,
        birthday: formatDate(customer.birthday),
        bankAccountNumber: customer.bankAccountNumber,
        bankCode: customer.bankCode,
        sipoNumber: customer.sipoNumber,
      })

      return response
    },
    async updateCustomer(context, customer) {
      const response = await http.put(`customer/${customer.id}/`, {
        name: customer.name,
        surname: customer.surname,
        titleBefore: customer.titleBefore,
        titleAfter: customer.titleAfter,
        gender: customer.genderName,
        phone: customer.phone,
        email: customer.email,
        birthday: formatDate(customer.birthday),
        bankAccountNumber: customer.bankAccountNumber,
        bankCode: customer.bankCode,
        sipoNumber: customer.sipoNumber,
      })

      return response
    },
    async getCustomer(context, id) {
      const response = await http.get(`customer/${id}`)

      return response
    },
    async deleteCustomer(context, { id, deleteOrders }) {
      const response = await http.delete(`customer/${id}?deleteOrders=${deleteOrders}`)

      return response
    },
    async mergeCustomer(context, { customer, mergeCustomerIds }) {
      const response = await http.post(`customer/${customer.id}/merge`, {
        customer: {
          name: customer.name,
          surname: customer.surname,
          titleBefore: customer.titleBefore,
          titleAfter: customer.titleAfter,
          gender: customer.genderName,
          phone: customer.phone,
          email: customer.email,
          birthday: formatDate(customer.birthday),
          bankAccountNumber: customer.bankAccountNumber,
          bankCode: customer.bankCode,
          sipoNumber: customer.sipoNumber,
        },
        address: {
          street: customer.address.street ? customer.address.street : '',
          houseNumber: customer.address.houseNumber ? customer.address.houseNumber : '',
          houseNumber2: customer.address.houseNumber2 ? customer.address.houseNumber2 : '',
          district: customer.address.district ? customer.address.district : '',
          city: customer.address.city ? customer.address.city : '',
          postalCode: customer.address.postalCode ? customer.address.postalCode : '',
        },
        contactAddress: {
          street: customer.contactAddress.street ? customer.contactAddress.street : '',
          houseNumber: customer.contactAddress.houseNumber
            ? customer.contactAddress.houseNumber
            : '',
          houseNumber2: customer.contactAddress.houseNumber2
            ? customer.contactAddress.houseNumber2
            : '',
          district: customer.contactAddress.district ? customer.contactAddress.district : '',
          city: customer.contactAddress.city ? customer.contactAddress.city : '',
          postalCode: customer.contactAddress.postalCode ? customer.contactAddress.postalCode : '',
        },
        mergeCustomerIds: mergeCustomerIds,
      })

      return response
    },
    async searchCustomerDuplicates(context, { id, params }) {
      const response = await http.get(`customer/${id}/duplicate/${requestUrlFunction(params)}`)

      return response
    },
    async searchCustomerDocuments(context, { id, params }) {
      const response = await http.get(`customer/${id}/document/${requestUrlFunction(params)}`)

      return response
    },
    async updateCustomerDocumentStatus(context, { id, documentId, status, statusMessage }) {
      const response = await http.post(`customer/${id}/document/${documentId}`, {
        status: status,
        statusMessage: statusMessage,
      })

      return response
    },
    async searchCustomers(context, params) {
      const response = await http.get(`customer/${requestUrlFunction(params)}`)

      return response
    },
    async searchCustomerAuditRevisions(context, { id, params }) {
      const response = await http.get(`customer/${id}/audit/revision/${requestUrlFunction(params)}`)

      return response
    },
    async searchCustomerPromoCodes(context, { id, params }) {
      const response = await http.get(`customer/${id}/promo-code/${requestUrlFunction(params)}`)

      return response
    },
    async searchCustomerPersonalizedOffers(context, { id, params }) {
      const response = await http.get(
        `customer/${id}/personalized-offer/${requestUrlFunction(params)}`
      )

      return response
    },
  },
}
